import { api } from "../api/client";

// The export endpoints require the bearer, so fetch through the API client
// (a plain <a href> wouldn't carry the Authorization header) and save it.
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

// Throws on failure (ApiError from the client) — callers surface the error.
export async function downloadCsv(path: string, filename: string): Promise<void> {
  const csv = await api<string>("GET", path);
  saveBlob(new Blob([csv], { type: "text/csv" }), filename);
}
